(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Add to cart animation
  document.querySelectorAll('.product-card__add-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      const btn = this.querySelector('.product-card__btn--cart');
      const originalHTML = btn.innerHTML;

      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!';
      btn.style.background = '#0D5204';

      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.style.background = '';
      }, 1500);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
